import React, { Component } from 'react';

import {
    Checkbox
} from 'library';

class CheckGroup extends React.Component {

    handleChange (e){
        var selection = e.currentTarget.value;
        var newState = {};

        var value = [];
        if (this.props.value && typeof(this.props.value) != 'undefined'){
            value = this.props.value;
        }
        var index = value.indexOf(selection);
        if (index == -1) {
            value.push(selection);
        } else {
            value.splice(index, 1);
        }

        newState[this.props.name] = value;

        this.props.setFormState(newState);
    }

    render() {
        var value = [];
        if (this.props.value && typeof(this.props.value) != 'undefined'){
            value = this.props.value;
        }

    	var type = " btn-" + this.props.type;

        var layout = 'form-group row';
        if (this.props.layout) {
            layout = 'form-group row ' + this.props.layout;
        }

        var label = null;
        if (this.props.label && this.props.label != ''){
            label = <label>{this.props.label}</label>;
        }

    	var buttons = [];
        var css = {}
    	for (var index in this.props.options) {
            var checked = false;
    	    if (value.indexOf(this.props.options[index].id) > -1) {
    	        checked = true;
    	    }

	        buttons.push(
                <Checkbox name={this.props.name} className="col-4"
                    checked={checked}
                    label={this.props.options[index].name}
                    value={this.props.options[index].id}
                    onChange={this.handleChange.bind(this)}
                />
            );
    	}

        return (
            <div className={layout} style={{'display':'block'}}>
                {label}
                <div className="row">
                    {buttons}
                </div>
            </div>
        );
    }
}

export default CheckGroup;
